/** Input classes of FormField — shared with custom controls (e.g. selects) rendered as FormField children. */
export function formFieldInputClassName(hasError = false, extra = ''): string {
  return `w-full px-3 py-1.5 rounded-md bg-white border text-[13px] text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#00A871]/30 focus:border-[#00A871]/50 disabled:bg-slate-50 disabled:cursor-not-allowed transition-colors ${
    hasError ? 'border-red-500 focus:ring-red-500/30' : 'border-slate-200'
  } ${extra}`;
}
